import { Check } from "lucide-react";

/**
 * KpiSelectedBadge — pastille verte avec check, positionnée en haut à droite
 * d'une carte KPI pour signaler la sélection active.
 *
 * Spec iter102 (Feb 2026) — renforcement visuel demandé sur Tâches,
 * Documents et AVI. Complémente le fond plein en couleur du module posé
 * sur la carte parente. Le parent doit être `position: relative`.
 *
 * Couleur imposée par la spec : #1e6b3e (même vert que le statut Clôturé).
 * Taille icône : 12-14 px pour tenir dans la pastille 18-20 px.
 */
export default function KpiSelectedBadge({ size = 20, testId }) {
  return (
    <span
      aria-hidden="true"
      className="absolute inline-flex items-center justify-center rounded-full pointer-events-none"
      style={{
        top: -6,
        right: -6,
        width: size,
        height: size,
        background: "#1e6b3e",
        color: "#FFFFFF",
        boxShadow: "0 2px 6px rgba(0,0,0,0.35), 0 0 0 2px #1B1B1B",
      }}
      data-testid={testId || "kpi-selected-badge"}
    >
      <Check size={Math.round(size * 0.65)} strokeWidth={3} />
    </span>
  );
}
